import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { Fabric } from '../../../../models/order/work-order';

@Component({
  selector: 'app-fabric-information-modal',
  templateUrl: './fabric-information-modal.component.html',
  styleUrl: './fabric-information-modal.component.scss',
})
export class FabricInformationModalComponent extends BaseModalComponent<Fabric | null> {
  @Input() fabric: Fabric | null = null;

  get fabricComposition() {
    const composition = this.fabric?.greige.fabricComposition.map((fc) => {
      return {
        compositionCode: fc.compositionCode,
        percentage: fc.percentage,
      };
    });

    return composition;
  }

  onClose() {
    this.close({ action: 'close', data: null });
  }
}
